import React from 'react';
import styled from 'styled-components';

interface TagInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onBlur: () => void;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown: (e: React.MouseEvent) => void;
  autoFocus?: boolean;
}

// タグ入力フィールド
const StyledTagInput = styled.input`
  width: 80px;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 2px 5px;
  font-size: 12px;
`;

const TagInput: React.FC<TagInputProps> = ({
  value,
  onChange,
  onKeyDown,
  onBlur,
  onClick,
  onMouseDown,
  autoFocus
}) => {
  return (
    <StyledTagInput
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      onClick={onClick}
      onMouseDown={onMouseDown}
      autoFocus={autoFocus}
      placeholder="タグ名"
    />
  );
};

export default TagInput; 